import {
  CommonDT,
  DateFilter,
  PageParams,
  ResultType,
  Sorter,
} from "../../CommonDT";
import { _delete, _get, _post, _put, _req } from "../../request";

export type ClockDataType = CommonDT & {
  userUuid: string;
  clockListUuid: string;
  clockDatetime: string;
  awardPointCount: number;
  awardTips: string;
};

export type ClockBatchDataType = {
  clocks: ClockDataType[];
};

export type ClockPageDataType = {
  pageParams: PageParams;
  filter?: ClockDataType;
  dateFilter?: DateFilter;
  sorter?: Sorter;
};

const get = async (id: string): Promise<ResultType> => {
  return await _get("/usr/clock/", id);
};

const list = async (data?: ClockDataType): Promise<ResultType> => {
  return await _post("/usr/clock/list", data);
};

const page = async (data?: ClockPageDataType): Promise<ResultType> => {
  return await _post("/usr/clock/page", data);
};

const batchSave = async (data: ClockBatchDataType): Promise<ResultType> => {
  return await _post("/usr/clock/batchSave", data);
};

const batchUpdate = async (data: ClockBatchDataType): Promise<ResultType> => {
  return await _put("/usr/clock/batchUpdate", data);
};

const alterStatus = async (
  clockId: string,
  status: number
): Promise<ResultType> => {
  return await _req("/usr/clock/alterStatus", "PUT", { clockId, status });
};

const batchRemove = async (ids: string[]): Promise<ResultType> => {
  return await _delete("/usr/clock/batchRemove", ids);
};

const userSign = async (userId: string): Promise<ResultType> => {
  return await _req("/usr/clock/userSign", "GET", { userId }, {});
};

const userSignList = async (userId: string): Promise<ResultType> => {
  return await _req("/usr/clock/userSignList", "GET", { userId }, {});
};

const todayOverSign = async (userId: string): Promise<ResultType> => {
  return await _req("/usr/clock/todayOverSign", "GET", { userId }, {});
};

const ClockApi = {
  get,
  list,
  page,
  batchSave,
  batchUpdate,
  alterStatus,
  batchRemove,
  userSign,
  userSignList,
  todayOverSign
};

export default ClockApi;
